import React, { useState, useEffect, useMemo } from "react";
import DataTable from 'react-data-table-component';
import Layout from "../../views/layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faBan, faUserMinus } from "@fortawesome/free-solid-svg-icons";
import Services from "../../services/global.service";
import DeleteModal from "../../components/modals/delete";

function Users() {
  const [users, setUsers] = useState([]);
  const [action, setAction] = useState("");
  const [actionText, setActionText] = useState("");
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [idToDeleted, setIdToDelete] = useState("");
  const [currentTab, setCurrentTab] = useState("actif");
  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);

  const customStyles = {
    table: {
      style: {
        backgroundColor: '#FCFCFC',
        fontSize: "16px",
      },
    },
    headCells: {
      style: {
        backgroundColor: '#F4F3F3',
        fontSize: "16px",
        fontFamily: 'Lato-Bold',
        fontWeight: '600',
      }
    },
    rows: {
      style: {
        cursor: 'pointer',
        backgroundColor: "#fff",
        fontSize: "16px",
        fontFamily: 'Lato-Light',
        minHeight: '64px'
      },
    },
  };

  const paginationComponentOptions = {
    rowsPerPageText: 'Lignes par page',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Tous',
  };

  const tabs = [
    { value: "actif", name: "Utilisateurs Actifs" },
    { value: "banned", name: "Utilisateurs bloqués" },
    { value: "deleted", name: "Utilisateurs supprimés" },
    { value: "all", name: "Tous" },
  ];

  function handleDelete(id) {
    setIdToDelete(id);
    setIsOpenDelete(true);
  }

  function handleDate(date) {
    const dateDans3Ans = new Date(date);
    dateDans3Ans.setFullYear(dateDans3Ans.getFullYear() + 3);
    const differenceEnMilliseconds = dateDans3Ans.getTime() - Date.now();
    return Math.ceil(differenceEnMilliseconds / (1000 * 60 * 60 * 24));
  }

  const columns = [
    {
      name: "Nom",
      selector: row => row.lastName,
      sortable: true,
      sortFunction: (a, b) => a.lastName.localeCompare(b.lastName, 'fr')
    },
    {
      name: "Prénom",
      selector: row => row.firstName,
      sortable: true,
      sortFunction: (a, b) => a.firstName.localeCompare(b.firstName, 'fr')
    },
    {
      name: "Téléphone",
      selector: row => row.tel,
      sortable: true,
      sortFunction: (a, b) => a.tel.localeCompare(b.tel)
    },
    {
      name: currentTab === "deleted" ? "Jours avant suppression" : "E-mail",
      selector: row => currentTab === "deleted" ? handleDate(row.updateAt) : row.email,
      sortable: true,
      sortFunction: (a, b) => {
        if (currentTab === "deleted") {
          return handleDate(a.updateAt) - handleDate(b.updateAt);
        }
        return a.email.localeCompare(b.email);
      }
    },
    ...(currentTab === "deleted" ? [{
      name: "Date suppression",
      selector: row => row?.updateAt,
      sortable: true,
      cell: row => row?.updateAt ? new Date(row.updateAt).toLocaleDateString('fr-FR') : '',
      sortFunction: (a, b) => new Date(a.updateAt) - new Date(b.updateAt)
    }] : []),
    {
      name: "Date de création compte",
      selector: row => row?.createdAt,
      sortable: true,
      cell: row => row?.createdAt ? new Date(row.createdAt).toLocaleDateString('fr-FR') : '',
      sortFunction: (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    },
    {
      name: "",
      cell: row => (
        <div className="btn-group" role="group" aria-label="Basic example">
          {row?.status === "actif" ? (
            <>
              <button
                type="button"
                className="btn-secondary-ko"
                title="Bloquer"
                onClick={() => {
                  handleDelete(row._id);
                  setIdToDelete(row._id);
                  setAction("banned");
                  setActionText("Bloquer");
                }}
              >
                <FontAwesomeIcon icon={faBan} />
              </button>
              <button
                type="button"
                className="mx-1 btn-secondary-ko"
                title="Supprimer"
                onClick={() => {
                  handleDelete(row._id);
                  setIdToDelete(row._id);
                  setAction("deleted");
                  setActionText("Supprimer");
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </>
          ) : row?.status === "banned" ? (
            <>
              <button
                type="button"
                className="mx-1 btn-secondary-ko"
                title="Débloquer"
                onClick={() => {
                  handleDelete(row._id);
                  setIdToDelete(row._id);
                  setAction("actif");
                  setActionText("Débloquer");
                }}
              >
                <FontAwesomeIcon icon={faUserMinus} />
              </button>
              <button
                type="button"
                className="btn-secondary-ko"
                onClick={() => {
                  handleDelete(row._id);
                  setIdToDelete(row._id);
                  setAction("deleted");
                  setActionText("Supprimer");
                }}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </>
          ) : null}
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  const subHeaderComponent = useMemo(() => {
    return (
      <>
        <div className='col-md-12'>
          <input
            className='form-control'
            id="search"
            type="text"
            placeholder="Recherche"
            value={filterText}
            onChange={e => setFilterText(e.target.value)}
          />
        </div>
        <div className="col-md-12 tabs-container mt-38">
          {tabs.map(tab => (
            <div 
              key={tab.value} 
              className={`tab ${currentTab === tab.value ? 'active' : ''}`} 
              onClick={() => setCurrentTab(tab.value)}
            >
              <a>{tab.name}</a>
            </div>
          ))}
        </div>
      </>
    );
  }, [filterText, currentTab]);

  useEffect(() => {
    if (users) {
      let filtered = users;
      
      if (currentTab !== 'all') {
        filtered = filtered.filter(item => item?.status === currentTab);
      }

      if (filterText) {
        filtered = filtered.filter(item => 
          JSON.stringify(item).toLowerCase().includes(filterText.toLowerCase())
        );
      }

      setFilteredItems(filtered);
    }
  }, [filterText, currentTab, users]);

  function getUsers() {
    Services.getAll("user/getAll", localStorage.getItem("token"))
      .then((response) => {
        setUsers(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const hideModal = () => {
    setIsOpenDelete(!isOpenDelete);
  };

  const handleUserAction = () => {
    const data = {
      status: action,
      id: idToDeleted,
      by: "admin",
    };

    Services.create(data, "user/updateStatus")
      .then(() => {
        getUsers();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getUsers();
  }, [isOpenDelete]);

  return (
    <Layout>
      {isOpenDelete && (
        <DeleteModal
          isOpenDelete={isOpenDelete}
          setIsOpenDelete={setIsOpenDelete}
          hideModal={hideModal}
          Function={handleUserAction}
          title={`Souhaitez-vous ${actionText} cette personne ?`}
        />
      )}
      <div className="col bg-fond container-k">
        <div className="m-vh-100 p-40">
          <div className="container">
            <div className="d-flex justify-content-between">
              <h1 className="d-title">Liste Utilisateurs <span className="border-title"></span></h1>
            </div>
            <div className="space-72"></div>
          </div>
          <div className="koper">
            {users && (
              <DataTable
                columns={columns}
                data={filteredItems}
                className="datatable-all mt-24"
                pagination
                onRowClicked={(row) => {
                  window.location.href = `/users/${row._id}`;
                }}
                paginationComponentOptions={paginationComponentOptions}
                customStyles={customStyles}
                subHeader
                subHeaderComponent={subHeaderComponent}
                noDataComponent={<div className="p-3">Aucun utilisateur trouvé</div>}
                defaultSortFieldId={5}
                defaultSortAsc={false}
              />
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Users;
